import { apiCall } from './generated/gqlClient';

const getMyBookedEvents = startTime => {
  const query = `
    query getMyBookedEvents($startTime: DateTime) {
      getMyBookedEvents(startTime: $startTime) {
        id
        subscriptionId
        userId
        provider {
          id
          name
          longitude
          latitude
          onlineDiscount
          acceptPayments
          freeCancellationHours
        }
        location {
          note
          address
          addressUrl
          url
        }
        locationType
        serviceId
        name
        description
        email
        startTime
        endTime
        type
        entityType
        status
        duration
        capacity
        totalCapacity
        classId
        subServiceId
        color
        pricingModel
        price
        paidWithUserMembershipId
        waitingListPosition
        serviceName
        resources {
          id
          name
        }
      }
    }
  `;

  return apiCall({ query, variables: { startTime } });
};

export { getMyBookedEvents };
